import AppForms from "@toothfairy/shared-ui/AppForms";

const parametersVal = AppForms.yup
  .object()
  .required()
  .nullable()
  .shape({
    type: AppForms.yup
      .string()
      .nullable()
      .oneOf(["object"], 'Type must be "object"')
      .required("Type is required"),
    properties: AppForms.yup
      .object()
      .required()
      .nullable()
      .test(
        "properties-structure",
        "Properties must contain valid field definitions",
        function (value) {
          if (!value) return true;

          // Each property should have description and type at minimum
          for (const [key, prop] of Object.entries(value)) {
            if (!prop || typeof prop !== "object") {
              return this.createError({
                path: `${this.path}.${key}`,
                message: `Property "${key}" must be an object`,
              });
            }

            if (!prop.type) {
              return this.createError({
                path: `${this.path}.${key}.type`,
                message: `Property "${key}" must have a type field`,
              });
            }

            if (!prop.description) {
              return this.createError({
                path: `${this.path}.${key}.description`,
                message: `Property "${key}" must have a description field`,
              });
            }
          }
          return true;
        }
      ),
    required: AppForms.yup
      .array()
      .nullable()
      .of(AppForms.yup.string().required("Required fields must be strings"))
      .test(
        "required-fields-exist",
        "Required fields must exist in properties",
        function (value) {
          if (!value || !this.parent.properties) return true;

          const properties = this.parent.properties;
          for (const field of value) {
            if (!properties[field]) {
              return this.createError({
                message: `Required field "${field}" must be defined in properties`,
              });
            }
          }
          return true;
        }
      ),
    additionalProperties: AppForms.yup.boolean().nullable().default(false),
  });

export default {
  parametersVal,
};
